import styles from "./styles.module.scss";

function Value() {
    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>Nos valeurs</div>
                <div className={styles.OneValue}>
                    <div className={styles.img}>
                        <img src="/images/values/collab.jpg" alt='img' />
                    </div>
                    <div className={styles.content}>
                        <text>Engagement</text>
                        <p>Permettre le succès de nos clients et leurs satisfaction, grâce à des équipes engagées
                            . Nous sommes à l’écoute de nos clients pour mieux le servir et nous cherchons sans cesse
                            le meilleur moyen pour les aider à créer de la valeur pour leurs clients.
                        </p>
                    </div>
                </div>
                <div className={styles.OneValue}>
                    <div className={styles.content}>
                        <text>Confiance</text>
                        <p>Bâtir une relation de confiance durable
                            avec nos client et nos collaborateurs.
                            Respect, solidarité, ouverture ainsi qu'échanges
                            transparente et sincéres indispensables
                            à la confiance
                        </p>
                    </div>
                    <div className={styles.img}>
                        <img src="/images/values/confiance.png" alt='img' />
                    </div>
                </div>
                <div className={styles.OneValue}>
                    <div className={styles.img}>
                        <img src="/images/values/innovation.jpg" alt='img' />
                    </div>
                    <div className={styles.content}>
                        <text>Innovation</text>
                        <p>Mettre à la disposition de nos clients des solutions performantes
                            , uniques et personnalisées. L’innovation, intégrée à une démarche qualité, 
                            est notre devise pour renforcer la différenciation et la compétitivité de nos clients.
                        </p>
                    </div>

                </div>
                <div className={styles.OneValue}>
                    
                    <div className={styles.content}>
                        <text>Efficacité</text>
                        <p>Déployer des solutions efficaces et chercher l’amélioration permanente
                            de nos outils et démarches d’intervention. 
                            Notre culture d’éditer, notre expertise métier,
                             notre maîtrise des solutions délitages et notre méthodologie agile permettent d’adresser 
                             à nos client dse conseils et des solutions efficientes et performantes.
                        </p>
                    </div>
                    <div className={styles.img}>
                        <img src="/images/values/efficacité.png" alt='img' />
                    </div>
                </div>

            </section>
        </>
    )
}

export default Value;